import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface SubscriptionResultDialogProps {
    isOpen: boolean;
    onConfirm?: () => void;
    onReject: () => void;
    children?: React.ReactNode;
    title: string;
    confirmButtonLabel?: string;
    rejectButtonLabel?: string;
}

export const RegistrationResultDialog = ({
    isOpen,
    onConfirm,
    onReject,
    title,
    confirmButtonLabel = 'Ok',
    rejectButtonLabel = 'Dismiss',
    children,
}: SubscriptionResultDialogProps) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onReject}
            aria-labelledby="result-dialog-title"
            aria-describedby="result-dialog-description"
            sx={{ '.MuiDialog-paper': { minWidth: 'min(40%, 500px)' } }}
        >
            <DialogTitle id="result-dialog-title" data-testid="result-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="result-dialog-description"
                    data-testid="result-dialog-description"
                    component="ul"
                    sx={{ pl: 0 }}
                >
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onReject} variant="text">
                    {rejectButtonLabel}
                </Button>
                {onConfirm && (
                    <Button
                        onClick={onConfirm}
                        autoFocus
                        variant="contained"
                        data-testid="result-dialog-confirm-button"
                    >
                        {confirmButtonLabel}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
